export default "/images/Leader.png?ec73c1ab146430d921026a22fef0c385";